import React from 'react';
import PropTypes from 'prop-types';
import { Translate, withLocalize } from 'react-localize-redux';
import Dialog from '@mui/material/Dialog';
import Button from '../../components/atoms/Button';
import Icon, { IconSizes, IconTypes, IconVariants } from '../../components/foundations/Icon';
import { TRANSLATION_KEY } from '../constants';
import css from './SlackConnectModal.css';

const PREFIX = `${TRANSLATION_KEY}.CONNECT_MODAL`;
const STEP_KEYS = ['ADD', 'TAG', 'ANSWER'];
const ACCESS_KEYS = ['MENTIONS_ONLY', 'PERMISSIONS', 'REMOVE'];

const SlackConnectModal = ({ open, busy = false, onContinue, onCancel, translate }) => (
    <Dialog
        open={open}
        onClose={busy ? undefined : onCancel}
        aria-labelledby="slack-connect-modal-title"
        BackdropProps={{ className: css.backdrop }}
        PaperProps={{ className: css.paper }}
    >
        <div className={css.header}>
            <div className={css.headings}>
                <h2 id="slack-connect-modal-title" className={css.title}>
                    <Translate id={`${PREFIX}.TITLE`} />
                </h2>
                <div className={css.subtitle}>
                    <Translate id={`${PREFIX}.SUBTITLE`} />
                </div>
            </div>
            <button
                type="button"
                className={css.close}
                aria-label={translate(`${PREFIX}.CANCEL`)}
                disabled={busy}
                onClick={onCancel}
            >
                <Icon
                    name="x"
                    type={IconTypes.TABLER}
                    size={IconSizes.SMALL}
                    variant={IconVariants.LIGHT}
                    interactive={false}
                />
            </button>
        </div>
        <div className={css.body}>
            <div className={css.steps}>
                <div className={css.sectionTitle}>
                    <Translate id={`${PREFIX}.HOW_IT_WORKS`} />
                </div>
                <ol className={css.stepList}>
                    {STEP_KEYS.map((key, index) => (
                        <li key={key} className={css.step}>
                            <span className={css.stepNumber}>{index + 1}</span>
                            <div>
                                <div className={css.stepTitle}>
                                    <Translate id={`${PREFIX}.STEPS.${key}.TITLE`} />
                                </div>
                                <div className={css.stepDescription}>
                                    <Translate id={`${PREFIX}.STEPS.${key}.DESCRIPTION`} />
                                </div>
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
            <div className={css.access}>
                <div className={css.accessTitle}>
                    <Icon name="lock" type={IconTypes.TABLER} size={IconSizes.X_SMALL} interactive={false} />
                    <Translate id={`${PREFIX}.ACCESS_TITLE`} />
                </div>
                {ACCESS_KEYS.map(key => (
                    <div key={key} className={css.accessItem}>
                        <Translate id={`${PREFIX}.ACCESS.${key}`} />
                    </div>
                ))}
            </div>
        </div>
        <div className={css.footer}>
            <span className={css.footerNote}>
                <Translate id={`${PREFIX}.FOOTER_NOTE`} />
            </span>
            <div className={css.footerActions}>
                <Button type="flat" disabled={busy} onClick={onCancel}>
                    <Translate id={`${PREFIX}.CANCEL`} />
                </Button>
                <Button showSpinner={busy} onClick={onContinue}>
                    <Translate id={`${PREFIX}.CONTINUE`} />
                </Button>
            </div>
        </div>
    </Dialog>
);

SlackConnectModal.propTypes = {
    open: PropTypes.bool.isRequired,
    busy: PropTypes.bool,
    onContinue: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(SlackConnectModal);
